<script setup lang="ts">
const {
  step,
  min,
  max,
  innerClass = "",
} = defineProps<{
  step?: number;
  min?: number;
  max?: number;
  innerClass?: string;
}>();

const stringValue = defineModel<string>();

type Slots = {
  prefix(): HTMLElement;
  suffix(): HTMLElement;
};

defineSlots<Slots>();

const increaseValue = () => {
  const newValue = Number(stringValue.value) + (step ?? 1);

  if (max && newValue > max) return;

  stringValue.value = String(newValue);
};

const decreaseValue = () => {
  const newValue = Number(stringValue.value) - (step ?? 1);

  if (min && newValue < min) return;

  stringValue.value = String(newValue);
};
</script>

<template>
  <FormKit
    v-bind="$attrs"
    v-model="stringValue"
    type="number"
    inputmode="numeric"
    :step="step ?? 1"
    :min="min"
    :max="max"
    outer-class="w-full"
    :inner-class="`hide-number-input-arrows ${innerClass}`"
  >
    <template #prefix>
      <slot name="prefix" />
    </template>
    <template #suffix>
      <slot name="suffix" />
      <div
        class="flex flex-col justify-center items-center pe-2 invisible w-0 ml-auto md:visible md:w-auto"
      >
        <button
          class="interaction-white"
          type="button"
          @click.prevent="increaseValue"
        >
          <BaseIcon
            name="chevronUp"
            :size="16"
          />
        </button>
        <button
          class="interaction-white"
          type="button"
          @click.prevent="decreaseValue"
        >
          <BaseIcon
            name="chevronDown"
            :size="16"
          />
        </button>
      </div>
    </template>
  </FormKit>
</template>
